<crm-shared-persons-vacation
  [currentOrFutureVacation]="currentOrFutureVacation"
  [educationService]="educationService"
  (sendOnVacation)="sendOnVacation($event)"
  (changeVacationDates)="changeVacationDates($event)"
  (returnFromVacation)="returnFromVacation()"
  (cancelVacation)="cancelVacation()"
></crm-shared-persons-vacation>
